import { useViewportSlots } from './use-viewport-slots';

import type { ViewportType } from '@/visualization/viewports/types';

export interface ViewportToolbarInfo {
    /** Viewport slot ID (e.g., "top-left", "3D-view") */
    id: string;
    /** Viewport type (VOLUME_3D, SLICE_AXIAL, etc.) */
    type: ViewportType;
    /** DOM container element to portal the toolbar into */
    container: HTMLElement;
}

/**
 * Hook that tracks active viewport toolbar containers.
 * Subscribes to ViewportLayoutService LAYOUT_CHANGED events and returns
 * metadata for each viewport that has a toolbar slot in the current layout.
 *
 * Built on top of useViewportSlots — use that hook directly when you need
 * access to multiple slots or slots other than 'toolbar'.
 */
export function useViewportToolbars(): ViewportToolbarInfo[] {
    const viewports = useViewportSlots(['toolbar']);

    return viewports
        .filter((vp) => vp.slotKind === 'viewport' && vp.slots.toolbar !== undefined)
        .map((vp) => ({
            id: vp.id,
            type: vp.type as ViewportType,
            container: vp.slots.toolbar!,
        }));
}
